var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcBimbinganKarir(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 54,
    viewBox: "0 0 55 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_14400_14915)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.6473 15.9219H21.1719V25.4141H37.6473L42.3933 20.668L37.6473 15.9219Z",
    fill: "#E63950"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.75507 6.32812L3.00897 11.1797L7.75507 15.9258H21.1718V6.32812H7.75507Z",
    fill: "#9999FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.24609 25.4219L0.5 30.168L5.24609 34.9141H21.1719V25.4219H5.24609Z",
    fill: "#9999FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5898 1.57812H22.7539V52.4141H19.5898V1.57812Z",
    fill: "#F0F7FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.1719 1.57812H22.7539V52.4141H21.1719V1.57812Z",
    fill: "#DFE7F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4258 0H25.918V3.16406H16.4258V0Z",
    fill: "#F0F7FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4258 50.8359H25.918V54H16.4258V50.8359Z",
    fill: "#61729B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.0186 38.0703H41.7383H31.7797L29.082 41.2344V53.9961H41.7383H54.5V41.2344L52.0186 38.0703Z",
    fill: "#47568C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.5 41.2344L52.0186 38.0703H41.7383V53.9961H54.5V41.2344Z",
    fill: "#29376D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.6029 30.6237C47.3944 30.4135 45.4508 28.5781 41.7383 28.5781C38.0258 28.5781 36.0822 30.4135 35.8737 30.6237L35.4102 31.0871V36.5037H38.5742V32.5347C39.1335 32.1994 40.1825 31.7421 41.7383 31.7421C43.2987 31.7421 44.3493 32.2025 44.9023 32.5315V36.4883H48.0664V31.0871L47.6029 30.6237Z",
    fill: "#47568C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.9023 36.4883H48.0664V31.0871L47.6029 30.6236C47.3944 30.4135 45.4508 28.5781 41.7383 28.5781V31.7422C43.2987 31.7422 44.3493 32.2026 44.9023 32.5316V36.4883Z",
    fill: "#007BC5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.7383 39.6562H40.1562V44.4023H41.7383H43.3203V39.6562H41.7383Z",
    fill: "#FFE666"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.7383 39.6562H43.3203V44.4023H41.7383V39.6562Z",
    fill: "#FFC34D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.7383 34.9062H29.082V41.2344H41.7383H54.5V34.9062H41.7383Z",
    fill: "#61729B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.7383 34.9062H54.5V41.2344H41.7383V34.9062Z",
    fill: "#47568C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.1719 0H25.918V3.16406H21.1719V0Z",
    fill: "#DFE7F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.1719 50.8359H25.918V54H21.1719V50.8359Z",
    fill: "#47568C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_14400_14915"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 54,
    height: 54,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcBimbinganKarir);
export default __webpack_public_path__ + "static/media/ic-bimbingan-karir.4c70ea1655fd66d4261940a9b0990be0.svg";
export { ForwardRef as ReactComponent };